<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
   

    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Home</p>
      </sidebar-link>
      <sidebar-link to="/newmemry">
        <md-icon>create</md-icon>
        <p>New Memry</p>
      </sidebar-link>
      <sidebar-link to="/memries">
        <md-icon>library_books</md-icon>
        <p>All Memries</p>
      </sidebar-link>
       <sidebar-link to="/memrytree">
        <md-icon>line_style</md-icon>
        <p>Memry Tree</p>
      </sidebar-link>
       <sidebar-link to="/drafts">
        <md-icon>drafts</md-icon>
        <p>Drafts</p>
      </sidebar-link>
      <sidebar-link to="/tags">
        <md-icon>account_tree</md-icon>
        <p>Manage Tags</p>
      </sidebar-link>
      <sidebar-link to="/info?insession=1">
        <md-icon>info</md-icon>
        <p>info</p>
      </sidebar-link>
      <sidebar-link to="/logout">
        <md-icon>power_settings_new</md-icon>
        <p>Logout</p>
      </sidebar-link>
      <!--
      <sidebar-link to="/icons">
        <md-icon>bubble_chart</md-icon>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/maps">
        <md-icon>location_on</md-icon>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/notifications">
        <md-icon>notifications</md-icon>
        <p>Notifications</p>
      </sidebar-link>
      <sidebar-link to="/upgrade" class="active-pro">
        <md-icon>unarchive</md-icon>
        <p>Upgrade to PRO</p>
      </sidebar-link>
      -->
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content> </dashboard-content>

      <!--<content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu
  }
};
</script>
